import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';

import { Text as BaseText, RButton, PrintBox } from '../../../../Components/Base';
import { SPACE, COLOR } from '../../../../Components/Theme';

const BlueBox = styled(props => <Box color="white" {...props} />)`
  background: linear-gradient(to bottom, #657b8f, ${COLOR.darkBlue});
  border-radius: 6px;
  position: relative;
`;

const Text = props => <BaseText color="inherit" lineHeight={1.6} {...props} />;

const TextRow = ({ label, value, labelWidth = 90 }) => {
  return (
    <Flex flexWrap="wrap">
      <Box flex={`0 0 ${labelWidth}px`}>
        <Text>{label}:</Text>
      </Box>
      <Box flex="1 1 auto">
        <Text>{value}</Text>
      </Box>
    </Flex>
  );
};

const Wrapper = styled(Box)`
  margin-top: 8px;
  text-align: right;
  @media (min-width: 768px) {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0 8px 8px 0;
  }
`;

const DownloadButton = ({ disabled, title, url }) => (
  <RButton
    variant="action"
    title={title}
    icon="get_app"
    iconRight
    is={!disabled && url !== null ? 'a' : undefined}
    href={url}
    disabled={disabled || url === null}
  />
);

DownloadButton.defaultProps = {
  url: null,
};

const ExamInfo = props => {
  const {
    subjectName,
    examCardDetail,
    mockExamDate,
    disableExamPaper,
    disableExamKey,
    downloadExamPaperUrl,
    downloadExamKeyUrl,
  } = props;
  const { seat, firstName, lastName } = examCardDetail;
  return (
    <Box mb={SPACE.large}>
      {/* <Text.Title pb={SPACE.medium}>{subjectName}</Text.Title> */}
      <BlueBox px={SPACE.medium} py={SPACE.small}>
        <TextRow label="ชื่อ-นามสกุล" value={`${firstName} ${lastName}`} />
        <TextRow label="วันสอบ" value={mockExamDate ? mockExamDate : '-'} />
        {/* <TextRow label="เวลา" value={mockExamTime ? mockExamTime : '-'} /> */}
        {/* <TextRow
          label="สถานที่สอบ"
          value={`อาคาร ${building ? building : '-'} ชั้น ${floor ? floor : '-'} ห้อง ${
            room ? room : '-'
          }`}
        /> */}
        <TextRow label="เลขที่นั่ง" value={seat} />
        <PrintBox display={'none'}>
          <Wrapper>
            <DownloadButton
              title={
                !disableExamPaper && downloadExamPaperUrl ? 'ดาวน์โหลดข้อสอบ' : 'ยังไม่มีข้อสอบ'
              }
              url={downloadExamPaperUrl}
              disabled={disableExamPaper}
            />
            <DownloadButton
              title={!disableExamKey && downloadExamKeyUrl ? 'ดาวน์โหลดเฉลย' : 'ยังไม่มีเฉลย'}
              url={downloadExamKeyUrl}
              disabled={disableExamKey}
            />
          </Wrapper>
        </PrintBox>
      </BlueBox>
    </Box>
  );
};

ExamInfo.defaultProps = {
  downloadExamPaperUrl: null,
  downloadExamKeyUrl: null,
};

export default ExamInfo;
